<template>
  <div class="join">
    <el-dialog width="650px" class="timeSetting" title="定时设置" v-if="showTime" :visible.sync="showTime" :before-close="handleClose">
       <time-setting :deviceInfo="deviceInfo" v-if="showTime" v-loading="loading" ></time-setting>
    </el-dialog>
    <div class="title"><img src="../assets/circle.png">
       <b>设备列表</b>
       <el-select class="selectSate" v-model="state" placeholder="请选择">
           <el-option
             v-for="item in options"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
         </el-select>
    </div>
    <div class="joinList">
      <table class="activeTable" cellspacing="0" cellpadding="0">
        <tr><th width="8%">设备ID</th><th width="12%">设备名称</th><!-- <th width="20%">设备地址</th> --><th width="10%">设备型号</th><th width="10%">单路/双路</th><th width="10%">状态</th><th width="10%">定时设置</th><!-- <th width="10%">定时设置</th> --></tr>
        <tr v-for="(item,index) in joinList" :key="item.id">
          <td align="center">{{item.deviceId}}</span></td>
          <td align="center"><span :title="item.deviceName">{{item.deviceName|cutstr(15)}}</span></td>
<!--          <td align="center">{{item.address}}</span></td> -->
          <td align="center">{{item.deviceType}}</span></td>
          <td align="center"><span>{{item.road|changeRoad}}</span></td>
          <td align="center">{{item.state|changeState}}</span></td>
          <td align="center"><span class="view" @click="viewTime(item.deviceId)">查看</span></td>
         <!-- <td align="center">{{item.deviceTime}}</span></td> -->
        </tr>
      </table>
      <div class="nodata" v-if="showNodata"><img src="../assets/no_data.png"><p>暂无数据</p></div>
    </div>
    <div class="page" v-if="!showNodata"><page :total='total' :currentPage='cur'  :pageSize='pageSize' @pageNum="getPage"></page></div>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import {getDeviceList,getDeviceDetail} from '@/api/api'
import bus from '@/bus'
import Page from '@/components/Page'
import {formatDate} from '@/api/common'
import EditType from '@/components/EditType'
import TimeSetting from '@/components/TimeSetting'
import Loading from '@/components/Loading'
export default {
  name: 'device',
  data () {
    return {
      joinList:[],
      memberInfo:{},
      deviceInfo:{},
      keyword:'',
      showNodata:false,
      showTime:false,
      showLoading:false,
      loading:false,
      state:'A',
      options: [
           {
              value: 'A',
              label: '全部'
          },
           {
              value: 'Y',
              label: '在线'
            }, {
              value: 'N',
              label: '离线'
            }],
      pageSize: 10, //每页几条
      cur: 1,//当前页码
      total:0 //总条数
    }
  },
  mounted(){
    bus.$off('closeEditMember')
    bus.$on('closeEditMember',res=>{
      this.showEditMember=false
      this.getData()
    })
    this.getData()
  },
  methods:{
    viewTime(id){
      var data=JSON.stringify({
          "deviceNumber": id,
      })
      this.showTime=true
      this.loading=true
      getDeviceDetail(data).then(res=>{
        this.loading=false
        if(res.data.state==200){
          this.deviceInfo=res.data.data
        }else{

        }
      }).catch(err=>{
        this.loading=false
      })


    },
    getData(){
      var data=JSON.stringify({
          "deviceId": "",
          "deviceNumber": "",
          "devOpsId": "",
          "usrId": "",
          "pageSize": this.pageSize,
          "currentPage": this.cur,
          "deviceState": this.state
      })
      this.showLoading=true
      getDeviceList(data).then(res=>{
        this.showLoading=false
        if(res.data.state==200){
          const {data}=res.data
          if(data==''||data==null){
            this.showNodata=true
          }else{
            this.showNodata=false
          }
          this.total=res.data.totalCount
          this.joinList=data
        }
      }).catch(err=>{
        this.showLoading=false
      })
    },
    handleClose(done) {
      done();
      this.tabIndex=0
      this.dayList=[]
      this.timeList=[]
    },
    getPage(data){
      this.cur=data
    }
  },
  filters:{
    changeRoad(val){
      if(val==1){
        return '单路'
      }
      if(val==2){
        return '双路'
      }
    },
    getTime(time) {
     var date = new Date(time);
     return formatDate(date, 'yyyy-MM-dd h:m:s').slice(0,16);
    },
    cutstr(val,len){
      if(val){
        return val.slice(0,len)
      }
    },
    cutserial(val){
       var len=val.toString().length
       console.log(len)
        if(len==1){
          return '00'+val
        }
        if(len==2){
          return '0'+val
        }
    },
    changeState(val){
      return val=='Y'?'在线':'离线'
    },
    changeTime(val){
      return parseFloat(val)/60
    }
  },
  watch:{
    cur(val){
      this.getData('')
    },
    state(val){
      this.cur=1
      this.getData()
    }
  },
  components:{
    Page,
    EditType,
    TimeSetting,
    Loading
  },
  // beforeRouteEnter(to,from,next) {
  //   var that=this
  //   var manager=localStorage.getItem('manager')
  //   if(manager=='M'){
  //     next()
  //   }else{
  //      alert('您没有访问权限')
  //      next('/login')
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .searchDiv {height:50px;line-height:50px;}
   .el-input {width:250px;margin-right:10px;}
   .joinList {height:500px;margin-top:20px;}
   .activeTable {width:100%;margin-top:5px;}
   .activeTable tr {height:40px;line-height:45px;}
   .activeTable tr input {width:16px;height:16px;position:relative;top:2px;}
   .activeTable tr th {font-weight: 100;background:#f6f6f6;}
   .activeTable tr td {border-bottom: #eee 1px solid;}
   .page {height:50px;}
   .searchDivLeft {width:400px;float: left;}
   .searchDivRight {width: 300px;text-align: right;float: right;}
   .options span {color:#fff;font-size:12px;padding:7px 10px;border-radius:4px;margin-left:5px;margin-right:5px;background:#409eff;cursor: pointer;}
   .addBn {float: right;}
   .view {color:#357af1;cursor: pointer;}
   .timeTable {width:100%;position: relative;top:-10px;border-collapse: collapse;}
   .timeTable th {height:35px;line-height:35px;background:#f4f4f4;}
   .timeTable td {height:30px;line-height:30px;text-align:center;border:#f4f4f4 1px solid;}
   .selectSate {width:100px;margin-left:20px}
   .timeSetting {min-height: 250px;}
</style>



// WEBPACK FOOTER //
// src/views/DeviceList.vue